// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".table td {\n  border: none;\n}\n.table thead th {\n  border-bottom: none;\n  font-family: \"Lato\", sans-serif;\n  font-size: 14px;\n}\n.table th {\n  border-bottom: none;\n  border-top: none;\n}\n.table-striped tbody td:last-child {\n  text-align: center;\n}\n.table-striped tbody tr:nth-of-type(odd) {\n  background-color: rgba(74, 98, 212, 0.05);\n}", ""]);
// Exports
module.exports = exports;
